module.exports = __webpack_public_path__ + "static/ff-clan-std-regular-a9b3a8d8f19d81c8c540735528a101c9.woff2";